// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"a806b89a","210":"160a6420","291":"b9e7ffff","347":"b9aa7076","453":"7ddb78b5","490":"108e5add","733":"4e57781a","872":"a2989ec7","900":"63ed1786","976":"f0ee9072"}[chunkId] + ".chunk.js";
};